import { render } from "./navbar-en.vue?vue&type=template&id=5c12072d&scoped=true"
import script from "./navbar-en.vue?vue&type=script&lang=js"
export * from "./navbar-en.vue?vue&type=script&lang=js"

import "./navbar-en.vue?vue&type=style&index=0&id=5c12072d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c12072d"]])

export default __exports__